import dayjs from 'dayjs'
export const dateFormat3 = function (dateinit) {
  if (dateinit === null || dateinit === 0 || dateinit === '' || dateinit === undefined) {
    return ''
  }
  return dayjs(dateinit).format('YYYY-MM-DD HH:mm:ss')
}
